import MyTeamTimestampComponent from "../components/MyTeamTimestamp";
import useMyTeamTimestamp from "../hooks/useMyTeamTimestamp";

function MyTeamTimestamp() {
  const useMyTeamTimestampProps = useMyTeamTimestamp();
  return <MyTeamTimestampComponent {...useMyTeamTimestampProps} />;
}

export default MyTeamTimestamp;
